import { HTTP } from '../../common/http';
import {
    SET_LAST_NAME,
    SET_BOOKING_REFERENCE,
    CLEAR_SEARCH,
    FETCH_COUNTRIES,
    FETCH_LOCATIONS,
    FETCH_USER_LOCATION,
    SET_MOCK_LOCATION,
    SET_SCREEN_TYPE,
    POST_SEARCH,
    SET_COUNTRY,
    SET_CURRENCY,
    SET_DRIVER_AGE,
    SET_DROPOFF_DATE,
    SET_DROPOFF_DIFFERENT,
    SET_DROPOFF_LOCATION,
    SET_DROPOFF_TIME,
    SET_GUEST_TOKEN,
    SET_PASSENGERS,
    SET_PICKUP_DATE,
    SET_PICKUP_LOCATION,
    SET_PICKUP_TIME,
    SET_PROMO_CODE,
    SET_QUOTE_ID,
    SET_UPDATE_QUOTE,
    SET_SEARCH_STATE,
    SET_TRANSMISSION,
    SET_AGENT_ID,
    USER_DEV_LOCATION,
    SET_CANCEL_DONATION,
    SET_RECREATE_QUOTE,
} from './mutation-types';

import { CREATE_QUOTE, FETCH_EXTRAS, SET_CUSTOMER, FETCH_NEW_QUOTE } from '../quotes/mutation-types';
import moment from 'moment';
import { assignDefaultVehicle, updateQuoteCreate } from '../quotes/actions';

export function fetchCountries({ commit }) {
    return HTTP.get(`countries`).then((response) => commit(FETCH_COUNTRIES, response.data.data));
}

export function fetchUserLocation({ commit }) {
    return HTTP.get(`locations/user-location`)
        .then((response) => {
            if (response.data.data) {
                commit(FETCH_USER_LOCATION, response.data.data);
            }
        })
        .catch((error) => '');
}

export function setDevLocation({ commit }, value) {
    commit(USER_DEV_LOCATION, value);
}

export function setCancelDonation({ commit }, value) {
    commit(SET_CANCEL_DONATION, value);
}

export function setLastName({ commit }, value) {
    commit(SET_LAST_NAME, value);
}

export function setBookingReference({ commit }, value) {
    commit(SET_BOOKING_REFERENCE, value);
}

export function setMockLocation({ commit }, location) {
    commit(SET_MOCK_LOCATION, location);
}

export function setScreenType({ commit }, screenType) {
    commit(SET_SCREEN_TYPE, screenType);
}

export function setCountry({ commit }, country) {
    commit(SET_COUNTRY, country);
}

export function fetchLocations({ commit }, data = null) {
    let parameters = 'include=country';

    if (data && data.country) {
        parameters += `&country_id=${data.country}`;
    }

    if (data && data.location_id) {
        parameters += `&location_id=${data.location_id}`;
    }

    return HTTP.get(`locations?${parameters}`).then((response) => commit(FETCH_LOCATIONS, response.data.data));
}

export function setPromoCode({ commit }, code) {
    commit(SET_PROMO_CODE, code);
}

export function setDriverAge({ commit }, age) {
    commit(SET_DRIVER_AGE, age);
}

export function setPassengers({ commit }, passengers) {
    commit(SET_PASSENGERS, passengers);
}

export function setTransmission({ commit }, transmission) {
    commit(SET_TRANSMISSION, transmission);
}

export function setDropoffDifferent({ commit }, different) {
    commit(SET_DROPOFF_DIFFERENT, different);
}

export function setPickupDate({ commit }, date) {
    commit(SET_PICKUP_DATE, date);
}

export function setPickupTime({ commit }, time) {
    commit(SET_PICKUP_TIME, time);
}

export function setDropoffDate({ commit }, date) {
    commit(SET_DROPOFF_DATE, date);
}

export function setDropoffTime({ commit }, time) {
    commit(SET_DROPOFF_TIME, time);
}

export function setPickupLocation({ commit }, location) {
    commit(SET_PICKUP_LOCATION, location);
}

export function setDropoffLocation({ commit }, location) {
    commit(SET_DROPOFF_LOCATION, location);
}

export function setAgentId({ commit }, agentId) {
    commit(SET_AGENT_ID, agentId);
}

export function setUpdateQuote({ commit }, updating) {
    commit(SET_UPDATE_QUOTE, updating);
}

export function postFrameSearch({ dispatch, state, commit }) {
    return new Promise((resolve, reject) => {
        basePostSearch(state)
            .then((response) => {
                commit(SET_CURRENCY, response.data.data.converted_currency || response.data.data.currency);
                commit(SET_QUOTE_ID, response.data.data.id);
                commit(SET_GUEST_TOKEN, response.data.data.guest_token);
                commit(SET_PROMO_CODE, response.data.data.promo_code);

                const details = {
                    id: response.data.data.id,
                    currency: response.data.data.converted_currency || response.data.data.currency,
                    guestToken: response.data.data.guest_token,
                };
                resolve(details);
            })
            .catch((error) => reject(error));
    });
}

export function postSearch({ dispatch, state, commit }) {
    return new Promise((resolve, reject) => {
        if (state.userLocation.countryCode === 'US') {
            dispatch('setDevLocation', true);
            dispatch('setMockLocation', 'US');
        }

        basePostSearch(state)
            .then((response) => {
                const quote = response?.data?.data;
                const id = quote?.id;

                if (!id) {
                    dispatch('clearVehicles');
                    dispatch('clearQuoteId');
                    return reject({ code: 'no_quote_id', response });
                }
                const currency = quote.converted_currency || quote.currency;

                commit(SET_CURRENCY, currency);
                commit(SET_QUOTE_ID, id);
                commit(SET_GUEST_TOKEN, quote.guest_token);
                commit(SET_PROMO_CODE, quote.promo_code);

                resolve(id);
            })
            .catch((error) => {
                dispatch('clearVehicles');
                dispatch('clearQuoteId');

                return reject(error);
            });
    });
}

export function updateQuoteSearch({ dispatch, state, commit }, { externalVehicleId, productId, mockState, bookingId, originalId = null, usSource = false }) {
    return new Promise(async (resolve, reject) => {
        let errorMessage = '';
        let vehicleDispatch = 'createVehicle';

        if (usSource || mockState === null) {
            vehicleDispatch = 'assignDefaultVehicle';
        }

        if (mockState === null) {
            mockState = state.search;
        }

        commit(SET_CANCEL_DONATION, true);

        //If no product id is available and the state is initially set to this dispatch method then it is likely US Source.
        if (mockState?.totals?.data?.base_rental > 0 || (typeof productId === 'undefined' && vehicleDispatch === 'assignDefaultVehicle') || usSource) {
            dispatch('setDevLocation', true);
            dispatch('setMockLocation', 'US');
            usSource = true;
        }

        await basePostSearch(state, null, mockState)
            .then(async (newQuoteResponse) => {
                originalId = originalId === null ? mockState.id : originalId;
                const quoteId = newQuoteResponse.data.data.id;
                const quote = newQuoteResponse.data.data;

                commit(SET_CURRENCY, newQuoteResponse.data.data.converted_currency || newQuoteResponse.data.data.currency);
                commit(SET_QUOTE_ID, newQuoteResponse.data.data.id);
                commit(FETCH_NEW_QUOTE, newQuoteResponse.data.data);
                commit(SET_GUEST_TOKEN, newQuoteResponse.data.data.guest_token);

                await dispatch('copyUpdateExtras', { quoteId, originalId })
                    .then(async (response) => {
                        await dispatch('fetchQuote', quoteId)
                            .then(async (newQuote) => {
                                await dispatch('fetchVehicles', {
                                    quoteId: quoteId,
                                    sortDriveAndGo: '&sort_drive_and_go',
                                })
                                    .then(async (response) => {
                                        // fetchVehicles already commits FETCH_VEHICLES itself (and skips the
                                        // commit if a newer fetchVehicles/fetchMoreVehicles call superseded this
                                        // one) - committing again here would re-apply a stale response. A
                                        // superseded response can also belong to a request that's since been
                                        // invalidated elsewhere, so abort this flow entirely rather than
                                        // selecting a vehicle and updating the quote from stale data.
                                        if (response.stale) {
                                            return reject('try_again_later');
                                        }

                                        let vehicle = response.data.data.find((vehicle) => vehicle.external_id === externalVehicleId);
                                        let updateQuoteResponse = null;
                                        //vehicle = void 0;//for testing purposes
                                        if (typeof vehicle === 'undefined' || usSource) {
                                            errorMessage = 'vehicle_not_available';
                                            await dispatch('updateQuoteCreate', {
                                                bookingId: bookingId,
                                                quoteId: quoteId,
                                                status: 'search',
                                            }).then(async (response) => {
                                                updateQuoteResponse = response;
                                                if (!usSource) {
                                                    const payment_type = quote.payment_type;
                                                    const green_heart_donation = mockState.green_heart_donation;
                                                    await dispatch('updateQuote', {
                                                        payment_type,
                                                        green_heart_donation,
                                                        quoteId,
                                                    });

                                                    await dispatch('updateQuoteCreate', {
                                                        bookingId: bookingId,
                                                        quoteId: originalId,
                                                    }).then((response) => {
                                                        if (response?.data?.errors) {
                                                            errorMessage = 'fetch_booking_update_failed';
                                                        }
                                                    });
                                                }

                                                if (response?.data?.errors) {
                                                    errorMessage = 'fetch_booking_update_failed';
                                                }
                                            });
                                        } else {
                                            await dispatch('updateQuoteCreate', {
                                                bookingId: bookingId,
                                                quoteId: quoteId,
                                            });
                                        }

                                        if ((productId && vehicleDispatch === 'createVehicle') || vehicleDispatch === 'assignDefaultVehicle') {
                                            await dispatch(vehicleDispatch, {
                                                selectedVehicle: vehicle,
                                                productId: productId,
                                                quoteId: quoteId,
                                            })
                                                .then(async (newVehicleResponse) => {
                                                    errorMessage = null;
                                                    await dispatch('fetchExtras', quoteId).then(async (response) => {
                                                        await dispatch('fetchTotals', quoteId).then(async (response) => {
                                                            await dispatch('fetchQuote', quoteId).then(async (response) => {
                                                                if (typeof vehicle !== 'undefined') {
                                                                    await dispatch('copyUpdateCustomer', {
                                                                        originalId,
                                                                    }).then((response) => {
                                                                        resolve({
                                                                            customer: response,
                                                                            newQuote: newQuote,
                                                                            newQuoteResponse: newQuoteResponse,
                                                                            vehicle: vehicle,
                                                                            updateQuote: updateQuoteResponse,
                                                                            newVehicleResponse: newVehicleResponse,
                                                                        });
                                                                    });
                                                                }
                                                            });
                                                        });
                                                    });
                                                })
                                                .catch((error) => reject('vehicle_not_available'));
                                        } else {
                                            resolve();
                                        }
                                    })
                                    .catch((error) => reject(errorMessage));
                            })
                            .catch((error) => reject('fetch_quote_failed'));
                    })
                    .catch((error) => reject('try_again_later'));
            })
            .catch((error) => reject(error));
    });
}

export function postPortalSearch({ dispatch, state, commit }, { url }) {
    return new Promise((resolve, reject) => {
        basePostSearch(state, url)
            .then((response) => {
                commit(SET_CURRENCY, response.data.data.converted_currency || response.data.data.currency);
                commit(SET_QUOTE_ID, response.data.data.id);
                commit(SET_GUEST_TOKEN, response.data.data.guest_token);
                resolve(response.data.data.id);
            })
            .catch((error) => reject(error));
    });
}

function getCurrentLocale() {
    if (window.greenmotion?.locale) {
        return window.greenmotion.locale;
    }

    const match = document.cookie.match(new RegExp('(^|;\\s*)locale=([^;]+)'));

    return match ? decodeURIComponent(match[2]) : 'en';
}

function getCookie(name) {
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
        cookie = cookie.trim();

        if (cookie.startsWith(name + '=')) {
            return decodeURIComponent(cookie.substring(name.length + 1));
        }
    }

    return null;
}

function basePostSearch(state, url, mockState = null) {
    const data = new FormData();
    const currentState = mockState || state.search;
    const pickupLocationId = currentState.pickupLocation ? currentState.pickupLocation.id : currentState.pickup_location_id;
    const dropoffLocationId = currentState.dropoffLocation ? currentState.dropoffLocation.id : currentState.dropoff_location_id;

    data.append('cancel_donation', state.search.cancel_donation);
    data.append('source_id', window.greenmotion.sourceId || 1);
    data.append('currency', currentState.currency || window.greenmotion.defaultCurrency || 'GBP');
    data.append('locale', getCurrentLocale());
    data.append('start_date', currentState.pickupDate || currentState.start_date);
    data.append('start_time', currentState.pickupTime || moment(currentState?.start_time, 'HH:mm:ss').format('HH:mm'));
    data.append('end_date', currentState.dropoffDate || currentState.end_date);
    data.append('end_time', currentState.dropoffTime || moment(currentState?.end_time, 'HH:mm:ss').format('HH:mm'));
    data.append('pickup_location_id', pickupLocationId);
    data.append('dropoff_location_id', currentState.dropoffDifferent ? dropoffLocationId : pickupLocationId);

    const promoCode = currentState.promoCode || currentState.promo_code;
    if (promoCode) {
        data.append('promo_code', currentState.promoCode || currentState.promo_code);
    }
    data.append('age', currentState.driverAge || currentState.age);
    data.append('referral_parameters', JSON.stringify(window.greenmotion.referral_parameters));

    const agentId = currentState.agentId || currentState.agent_id;

    if (agentId) {
        data.append('agent_id', agentId);
    }

    const recreateQuote = state.recreateQuote;

    if (recreateQuote) {
        data.append('recreate_quote_id', recreateQuote);
    }

    const visitorId = getCookie('experiment_visitor_id');

    if (visitorId) {
        data.append('visitor_id', visitorId);
    }

    if (!pickupLocationId || !currentState.pickupDate || !currentState.dropoffDate) {
        return Promise.reject({
            code: 'invalid_search_state',
            message: 'Missing required search parameters',
        });
    }

    return HTTP.post(url ? url : `quotes`, data);
}

export function clearSearch({ commit }) {
    commit(CLEAR_SEARCH);
}

export function postFindBooking(state, { formData }) {
    const data = new FormData();

    data.append('booking_reference', formData.bookingReference);
    data.append('last_name', formData.lastName);

    return HTTP.post('find-booking', data);
}

export function setGuestToken({ commit }, { guestToken }) {
    return new Promise((resolve, reject) => {
        commit(SET_GUEST_TOKEN, guestToken);
        resolve(guestToken);
    });
}

export function setRecreateQuote({ commit }, id) {
    commit(SET_RECREATE_QUOTE, id);
}

export function clearQuoteId({ commit }) {
    commit(SET_QUOTE_ID, null);
}

/*
export function fetchGuestToken({commit }){
  return new Promise((resolve,reject) => {
    localStorage.getItem('guestToken');
    resolve(localStorage.getItem('guestToken'))
  }).then((value) => {
    console.log(value);
    // commit(SET_GUEST_TOKEN,value);
  });
}*/
